/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it add 'and' (e.g. 'one hundred and one')?`)
};

const es_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Agrega 'and' (p. ej. 'one hundred and one')?`)
};

const de_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird 'and' hinzugefügt (z. B. 'one hundred and one')?`)
};

const nl_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voegt het 'en' toe (bijv. 'one hundred and one')?`)
};

const fr_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoute-t-il 'and' (par exemple 'one hundred and one') ?`)
};

const it_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiunge 'and' (es. 'one hundred and one')?`)
};

const pt_br2_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele adiciona "e" (ex: "cento e um")?`)
};

const pt_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adiciona 'and' (p.ex. 'one hundred and one')?`)
};

const ja_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「and」を追加しますか？（例：「one hundred and one」）`)
};

const zh_nw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会添加“and”吗（例如“one hundred and one”）？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq2_q", locale)
	if (locale === "en") return en_nw_faq2_q(inputs)
	if (locale === "es") return es_nw_faq2_q(inputs)
	if (locale === "de") return de_nw_faq2_q(inputs)
	if (locale === "nl") return nl_nw_faq2_q(inputs)
	if (locale === "fr") return fr_nw_faq2_q(inputs)
	if (locale === "it") return it_nw_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq2_q(inputs)
	if (locale === "pt") return pt_nw_faq2_q(inputs)
	if (locale === "ja") return ja_nw_faq2_q(inputs)
	return zh_nw_faq2_q(inputs)
};